import { render, staticRenderFns } from "./Island.vue?vue&type=template&id=49d30788&scoped=true&"
import script from "./Island.vue?vue&type=script&lang=js&"
export * from "./Island.vue?vue&type=script&lang=js&"
import style0 from "./Island.vue?vue&type=style&index=0&id=49d30788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d30788",
  null
  
)

export default component.exports